import { createSelector } from '@ngrx/store';
import { selectValidationRulesState } from '..';
import { ICrossFieldRule, IValidatorRule } from '../../models/validation-rule';

export const selectFieldRules = createSelector(
  selectValidationRulesState,
  (state) => state.fieldRules,
);

export const selectCrossFieldRules = createSelector(
  selectValidationRulesState,
  (state) => state.crossFieldRules,
);

export const selectCatalog = createSelector(selectValidationRulesState, (state) => state.catalog);

export const selectLoading = createSelector(selectValidationRulesState, (state) => state.loading);

export const selectSelectedSourceTypeId = createSelector(
  selectValidationRulesState,
  (state) => state.selectedSourceTypeId,
);

export const selectSelectedTemplateId = createSelector(
  selectValidationRulesState,
  (state) => state.selectedTemplateId,
);

export const selectSelectedKind = createSelector(
  selectValidationRulesState,
  (state) => state.selectedKind,
);

/**
 * Field rules attached to the currently selected template. Returns an empty
 * array when nothing is selected so consumers can render unconditionally.
 */
export const selectFieldRulesForSelectedTemplate = createSelector(
  selectFieldRules,
  selectSelectedTemplateId,
  (rules, templateId): IValidatorRule[] => {
    if (templateId === null) return [];
    return rules.filter((r) => r.metadata_template === templateId);
  },
);

/**
 * Cross-field rules where the currently selected template appears on EITHER
 * side. Useful for "what cross-field rules involve this template?" without
 * the caller having to express that condition by hand.
 */
export const selectCrossFieldRulesForSelectedTemplate = createSelector(
  selectCrossFieldRules,
  selectSelectedTemplateId,
  (rules, templateId): ICrossFieldRule[] => {
    if (templateId === null) return [];
    return rules.filter(
      (r) => r.left_template === templateId || r.right_template === templateId,
    );
  },
);

/**
 * All CROSS_FIELD_VALUE_DEPENDENCY rules. The Location Hierarchy tab uses
 * this slice and reconstructs the country/state tree client-side.
 */
export const selectValueDependencyRules = createSelector(
  selectCrossFieldRules,
  (rules): ICrossFieldRule[] =>
    rules.filter((r) => r.rule_type === 'CROSS_FIELD_VALUE_DEPENDENCY'),
);

// ---- Configurable catalog selectors -------------------------------

export const selectOperations = createSelector(
  selectValidationRulesState,
  (state) => state.operations,
);

export const selectRuleTypeDefs = createSelector(
  selectValidationRulesState,
  (state) => state.ruleTypeDefs,
);
